<template>
    <v-container>
        <v-form ref="form">
            <v-row>
            <v-text-field
                :value="name"
                label="Name"
            ></v-text-field>
            </v-row>

            <v-row>
                <v-spacer></v-spacer>

                <v-btn>
                    Save
                </v-btn>
            </v-row>

        </v-form>
    </v-container>
</template>

<script>
  const { rest } = require('../misc/rest')
  import { mapState } from 'vuex'
  const moment = require('moment-timezone')

  export default {
    name: 'Applause',

    components: {
    },

    props: {
        id: String,
        name: String,
    },

    data: () => ({
    }),

    methods: {
    },

    created() {
    },

    mounted() {
    },
  }
</script>
